<template>
  <v-flex xl6 md6 sm12 xs12 pr-0 mr-0>
    <v-layout column justify-center>
      <v-flex xl6 md6 sm12 xs12 class="text-center">
        <h3 class="display-2">{{ $t('select_time') }}</h3>
      </v-flex>
      <!--<v-flex xl6 md6 sm12 xs12 text-center>
        <v-layout row border>
          <v-flex><v-btn class="l-btn grayed v-btn theme--light"></v-btn> - {{ $t("select_avaliable") }}</v-flex>
          <v-flex><v-btn class="l-btn v-btn v-btn--active theme--light"></v-btn> - {{ $t("selected") }}</v-flex>
        </v-layout>
      </v-flex>-->
      <v-flex xl6 md6 sm12 xs12 p-0>
        <v-card class="draw">
          <v-card-title><v-flex text-center p-0 m-0><h3 subheading>{{ $t("avaliable_times") }}</h3></v-flex></v-card-title>
          <v-card-text>
            <v-btn-toggle mandatory name="time" v-model="toggle_exclusive" @change=timeChanged>
                <v-btn v-for="item in items" :key="item">
                  {{ item.substring(0, item.length - 3) }}
                </v-btn>
            </v-btn-toggle>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-flex>
</template>

<script>
export default {
  name: "rTimeLoader",
  props: ["times"],
  data: function() {
    return {
      toggle_exclusive: null
    };
  },
  computed: {
    items: function() {
      let timesList = [];
      this.times.forEach(function(value) {
        timesList.push(value.time);
      });
      return timesList.sort();
    }
  },
  methods: {
    timeChanged: function(event) {
      this.$emit("timeChanged", this.items[event]);
    }
  }
};
</script>

<style scoped>
.v-btn-toggle {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  align-self:flex-start;
}

.v-btn-toggle--selected{
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.v-btn-toggle /deep/ .v-btn{
  margin: 0.5em;
}

.draw{
  animation-duration: 2s;
  animation-iteration-count: 2;
  animation-name: plum;
}

@keyframes plum {
  0%   {background-color: white; left:0px; top:0px;}
  50% {background-color: var(--v-secondary-base); left:0px; top:0px;}
  100%   {background-color: white; left:0px; top:0px;}
}

.v-btn--flat:not(.v-btn--disabled){
  background-color: var(--v-primary-base)!important;
  color: white !important;
}

.v-btn--active{
  background-color: var(--v-accent-base) !important;
  color: black !important;
}

.grayed{
  color: #a5a5a5 !important;
}
</style>